module.exports = __webpack_public_path__ + "static/img/輾二-陳冠羽.5a1011c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/輾二-陳冠羽.jpg
// module id = 3MsC
// module chunks = 1